import { jsxs as a, Fragment as T, jsx as e } from "../../_virtual/jsx-runtime.mjs";
import * as p from "react";
import { w as S } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import b from "../../Basic/LoadingBar/LoadingBar.mjs";
import m from "../ReoIcon/ReoIcon.mjs";
import x from "../ReoPopup/ReoPopup.mjs";
import N from "../ReoButton/index.mjs";
import { getFileBlob as k } from "../../utils/fileUtil.mjs";
import { FILE_STATUS as I, ONE_MEGABYTE as U } from "./const.mjs";
import { draggedUploadListTemplate as y } from "../../assets/css/themes/template/draggedUploadTemplate.mjs";
import { uploadList as E, closeIcon as g, popupCls as L, popupContentCls as M, closeIconWrap as A, popupImgContainer as W, previewMedia as B, listItemStatus as j, listItemContent as z, removePopupContent as G, removePopupBtnGroup as O, listItemIcon as F, fileInfo as D, fileName as _, fileSize as H, listItemRemoveIcon as J, playBtn as K } from "./css/draggedUpload.mjs";
import X from "../../depend/classnames/index.mjs";
const Y = (o) => {
  var n, d, t;
  const i = p.useMemo(() => o.uploadFile.status === I.UPLOADING, [o.uploadFile.status]), [v, r] = p.useState(!1), c = () => {
    r(!1);
  }, u = /video/g.test(o.uploadFile.type ?? "") ? "video" : "image", l = (s) => {
    s.stopPropagation(), o.handleRemoveItem(o.uploadFile), r(!1);
  }, h = (s) => {
    o.removePopupConf.showRemoveReconfirm ? r(!0) : l(s);
  }, f = (s) => {
    o.previewFile(o.uploadFile, s);
  }, C = () => /* @__PURE__ */ e(
    m,
    {
      className: F,
      width: 15,
      color: i ? "var(--icon-loading-color)" : "var(--color)",
      spin: i,
      name: i ? "icon-icon-loading-1" : "icon-attach-file"
    }
  ), R = () => /* @__PURE__ */ a("div", { className: D, children: [
    /* @__PURE__ */ e("div", { className: X(_, "reo-basic-upload-item-filename"), children: o.uploadFile.name }),
    o.listType === "picture" ? /* @__PURE__ */ a("div", { className: H, children: [
      (o.uploadFile.size / U).toFixed(2),
      "MB"
    ] }) : null,
    i ? /* @__PURE__ */ e(
      b,
      {
        shortBarStyle: { height: "6px" },
        longBarStyle: { height: "6px" },
        animation: !1,
        longBarWidth: "100%",
        shortBarWidth: `${o.uploadFile.percent}%`,
        longBarColor: y.item.loadingBar.longBarColor,
        shortBarColor: y.item.loadingBar.shortBarColor
      }
    ) : null
  ] }), P = () => /* @__PURE__ */ e(
    m,
    {
      onClick: h,
      className: J,
      width: 20,
      name: "icon-bin-line"
    }
  ), w = () => o.uploadFile.thumbnailUrl ? /* @__PURE__ */ a("div", { onClick: f, children: [
    u === "video" && /* @__PURE__ */ e("div", { className: K, children: /* @__PURE__ */ e(
      m,
      {
        color: "#fff",
        width: "var(--icon-size)",
        name: "icon-icon-new-play",
        style: { marginLeft: "3px" }
      }
    ) }),
    /* @__PURE__ */ e(
      "img",
      {
        src: o.uploadFile.thumbnailUrl,
        alt: "",
        className: F,
        width: "50px",
        height: "50px"
      }
    )
  ] }) : /* @__PURE__ */ e(
    m,
    {
      width: "40px",
      height: "40px",
      className: F,
      color: "var(--color)",
      name: "icon-attach-file"
    }
  );
  return /* @__PURE__ */ a(
    "li",
    {
      className: j[o.uploadFile.status ?? I.SUCCESS],
      children: [
        /* @__PURE__ */ a("div", { className: z, children: [
          o.listType === "picture" ? w() : C(),
          R(),
          P()
        ] }),
        o != null && o.listItemRender ? /* @__PURE__ */ e(
          o.listItemRender,
          {
            uploadFile: o.uploadFile
          },
          o.uploadFile.uid
        ) : null,
        o.removePopupConf.showRemoveReconfirm ? /* @__PURE__ */ a(
          x,
          {
            open: v,
            popupType: "form",
            onClose: c,
            mask: !0,
            children: [
              /* @__PURE__ */ e("div", { className: G, children: ((n = o.removePopupConf.removePopUpInfo) == null ? void 0 : n.contentText) ?? "Are you sure you want to delete the video?" }),
              /* @__PURE__ */ a("div", { className: O, children: [
                /* @__PURE__ */ e(
                  N,
                  {
                    activeBackgroundColor: "#E53C15",
                    activeBorderColor: "#FF4317",
                    borderColor: "#FF4317",
                    backgroundColor: "#FF4317",
                    onClick: l,
                    style: { marginRight: "20px" },
                    children: ((d = o.removePopupConf.removePopUpInfo) == null ? void 0 : d.confirmationText) ?? "Delete"
                  }
                ),
                /* @__PURE__ */ e(
                  N,
                  {
                    activeBackgroundColor: "#00783F",
                    activeBorderColor: "#00783F",
                    borderColor: "#00783F",
                    color: "#00783F",
                    backgroundColor: "transparent",
                    onClick: c,
                    children: ((t = o.removePopupConf.removePopUpInfo) == null ? void 0 : t.cancelText) ?? "Cancel"
                  }
                )
              ] })
            ]
          }
        ) : null
      ]
    },
    o.uploadFile.uid
  );
}, q = (o) => {
  var n;
  const [d, t] = p.useState(!1), [i, v] = p.useState(), r = p.useRef(null), c = (l) => {
    const h = /video/g.test(l.type ?? "") ? "video" : "image", f = k(l.originFileObj), C = {
      name: l.name ?? "",
      fileType: h,
      url: f
    };
    v(C), t(!0);
  }, u = () => {
    var l;
    (l = r.current) == null || l.pause(), t(!1);
  };
  return /* @__PURE__ */ a(T, { children: [
    /* @__PURE__ */ e("ul", { className: E, children: (n = o.uploadFiles) == null ? void 0 : n.map((l) => /* @__PURE__ */ e(
      Y,
      {
        listType: o.listType,
        uploadFile: l,
        handleRemoveItem: o.onRemove,
        previewFile: c,
        listItemRender: o.listItemRender,
        removePopupConf: o.removePopupConf
      },
      l.uid
    )) }),
    /* @__PURE__ */ e(
      x,
      {
        childrenMaxHeight: 450,
        onClose: u,
        iconClass: g,
        iconWrapClass: g,
        open: d,
        theme: o == null ? void 0 : o.theme,
        className: L,
        mask: !0,
        contentStyle: { padding: 0 },
        contentClassName: M,
        closeIconNode: /* @__PURE__ */ e(
          "div",
          {
            onClick: u,
            className: A,
            children: /* @__PURE__ */ e(
              m,
              {
                className: g,
                name: "icon-icon-error-4",
                color: "#fff",
                width: 10
              }
            )
          }
        ),
        children: /* @__PURE__ */ e(
          "div",
          {
            className: W,
            children: (i == null ? void 0 : i.fileType) === "video" ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
              "video",
              {
                className: B,
                ref: r,
                src: i == null ? void 0 : i.url,
                controls: !0,
                autoPlay: !0,
                playsInline: !0,
                muted: !0
              }
            ) }) : /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
              "img",
              {
                src: i == null ? void 0 : i.url,
                alt: "",
                className: B
              }
            ) })
          }
        )
      }
    )
  ] });
};
S(q, {});
//# sourceMappingURL=DraggedUploadList.mjs.map
